import React from "react";
import { ProjectCard } from "../../Components";
import { Container, Row, Col } from "react-bootstrap";
import Instagram from "../../Assets/projects/Instagram.webp";
import UdteyKadam from "../../Assets/projects/udtey-logo.jpeg";
import Abhianna from "../../Assets/projects/e-learning.jpeg";
import WomenSecurityApp from "../../Assets/projects/womenSecurityApp.jpeg";
import Zoom from "../../Assets/projects/zoom.png";
import "../../Styles/project.css";
import Particle from "../Particle";


const Project = () => {
 const techStacksForWomenSecurityApp = ["Dart","Flutter","Firebase","Google Maps","Authentication"]
 const techStacksForUKFC = ["React","Firebase","Redux","Styled Components","Authentication"]
 const techStacksForELearning = ["HTML","CSS","JavaScript","Jquery","Axios"]
 const techStackForInstagram = ["React Native","Firebase","Styled Component"]
 const techStackForZoom = ["React","Firebase","Styled Component"]
  return (
    <div id="projects" style={{paddingTop: '3rem'}}>
    <Container
      fluid
      className="project-section"
      >
    
      <Container>
      <div>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        </div>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={WomenSecurityApp}
              isBlog={false}
              title="Women security App "
              description="This project is to ensure every woman in our society to feel safe and secured. Features:
            User Authentication, Gps and live location and send sos."
              link="https://github.com/Lyghtjr/Women-Security-App-Sambhav"
              techstacks = {techStacksForWomenSecurityApp}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={UdteyKadam}
              isBlog={false}
              title="Udtey kadam foundation"
              description="The Udtey Kadam Foundation provides an opportunity for the maximum development of talent among young people in the field of Cricket and Football."
              link="https://udtey-kadam-foundation.vercel.app/"
              techstacks={techStacksForUKFC}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Abhianna}
              isBlog={false}
              title="Abhianna"
              description="The software is designed to provide the education each and every student.It is used to manage the details of Assignment, Student, TEACHER, QUIZ, and QUESTION."
              link="https://lyghtjr.github.io/Abhianna/"
              techstacks={techStacksForELearning}
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Instagram}
              isBlog={false}
              title="Instagram Clone"
              description="Create an account or log in to Instagram - A simple, fun & creative way to capture, edit & share photos, videos & messages with friends & family."
              link="https://github.com/Lyghtjr/RN-INSTAGRAM-CLONE"
              techstacks={techStackForInstagram}
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Zoom}
              isBlog={false}
              title="Zoom Clone"
              description="Zoom's secure, reliable video platform powers all of your communication needs, including meetings, chat, phone, webinars, and online events."
              link="  https://quiet-bayou-46663.herokuapp.com/aca1f810-be25-4953-82e1-eb78b38057af"
              techstacks={techStackForZoom}
            />
          </Col>
        </Row>
      </Container>
    </Container>
    </div>
  );
};

export default Project;
